import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const router = new Router({
  routes: [
    { path: '/', redirect: '/cockpit' },
    { path: '/device', component: () => import('@/views/device') },
    { path: '/suyuan', component: () => import('@/views/suyuan') },
    { path: '/base', component: () => import('@/views/base') },
    { path: '/price', component: () => import('@/views/price') },
    { path: '/cockpit', component: () => import('@/views/cockpit') },
  ]
});

export default router;